<template>
  <div id="danger">
    <div class="error-page">
      <div class="error-page-heading">
        <h1>STOP</h1>
      </div>
      <h2>BẠN KHÔNG ĐƯỢC PHÉP SỬ DỤNG PHẦN MỀM NÀY</h2>
      <p>
        Bạn đang sử dụng một phiên bản không hợp pháp của chương trình này. vui
        lòng liên hệ nhà phát triển để được cung cấp bản quyền sử dụng
        <a href="https://dsolu.com">LIÊN HỆ NHÀ PHÁT TRIỂN</a>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "danger",
  layout: "blank",
  meta: {
    danger: true
  },
  props: {}
};
</script>
